// extracted by mini-css-extract-plugin
export default {"card":"w6-z"};